/**
 * @file Auras FX (cosmetiques, boutique uniquement) : achat en gemmes / Rubis, equipement, interrupteur FX.
 */
import { fail, okVoid } from '@shared/types';
import type { Result } from '@shared/types';
import type { AuraStyle } from '@config/types';
import type { SimContext } from '../Context';

export class AuraService {
  constructor(private readonly ctx: SimContext) {}

  owns(id: string): boolean {
    return this.ctx.data.auras.owned.includes(id);
  }

  /** Style de l'aura a dessiner autour du chef (null = aucune ou FX coupes). */
  activeStyle(): AuraStyle | null {
    const a = this.ctx.data.auras;
    if (!a.enabled || a.equipped === null) return null;
    return this.ctx.index.aura(a.equipped).style;
  }

  buy(id: string): Result {
    const ctx = this.ctx;
    const aura = ctx.config.auras.find((s) => s.id === id);
    if (!aura) return fail('unknownId');
    if (this.owns(id)) return fail('alreadyOwned');
    return ctx.tx.purchase(aura.cost, `aura:${id}`, () => {
      ctx.data.auras.owned.push(id);
      ctx.bus.emit('AuraBought', { id });
      return okVoid;
    });
  }

  /** Equipe une aura possedee (null = retirer). Equiper active aussi les FX. */
  equip(id: string | null): Result {
    const ctx = this.ctx;
    if (id !== null) {
      if (!ctx.config.auras.some((s) => s.id === id)) return fail('unknownId');
      if (!this.owns(id)) return fail('notOwned');
      ctx.data.auras.enabled = true;
    }
    ctx.data.auras.equipped = id;
    ctx.bus.emit('AuraEquipped', { id });
    return okVoid;
  }

  toggle(enabled?: boolean): Result {
    const a = this.ctx.data.auras;
    a.enabled = enabled ?? !a.enabled;
    this.ctx.bus.emit('AuraToggled', { enabled: a.enabled });
    return okVoid;
  }
}
